import { IconButton, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";

export default function ColorModeButton() {
  const { colorMode, toggleColorMode } = useColorMode();
  // Define consistent colors for light and dark modes
  const iconColor = useColorModeValue("#4b635e", "#E9A6A6");
  const icon =
    colorMode === "light" ? (
      <MoonIcon color={iconColor} />
    ) : (
      <SunIcon color={iconColor} />
    );

  return (
    <IconButton
      aria-label="Toggle color mode"
      icon={icon}
      onClick={toggleColorMode}
      size="md"
      boxShadow="lg"
    />
  );
}
